export enum COLLECTION_PRESENTATION_TYPE {
  ONE_ROW = 'oneRowSwimlane',
  TWO_ROWS = 'twoRowSwimlane'
}
